import { toast } from "react-toastify";

export function compressAmount(amount) {
  if (amount >= 10000000) {
    return "₹" + (amount / 10000000).toFixed(1) + " Cr";
  } else if (amount >= 100000) {
    return "₹" + (amount / 100000).toFixed(1) + " L";
  } else {
    return "₹" + amount?.toString();
  }
}


export function getModeName (type) {
  if (Number(type) == 1) return "CASH";
  else if (Number(type) == 2) return "UPI";
  else if (Number(type) == 3) return "NET_BANKING";
  else if (Number(type) == 4) return "CARD";
  else return "UPI";
}

export function capitalizeFirstLetter (str) {
  return str
    .split(" ") // Split the string into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(" "); // Join the words back into a string
};


export function handleCopy(numberToCopy) {
  const textToCopy = String(numberToCopy || "");

  if (!textToCopy) {
    toast.error("Nothing to copy");
    return;
  }

  // Modern approach with fallback
  if (navigator.clipboard?.writeText) {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => toast.success("Copied to clipboard"))
      .catch(() => copyUsingFallback(textToCopy));
  } else {
    copyUsingFallback(textToCopy);
  }
}

function copyUsingFallback(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.select();

  try {
    document.execCommand("copy");
    toast.success("Copied to clipboard");
  } catch (err) {
    toast.error("Failed to copy. Please select and copy manually.");
  } finally {
    document.body.removeChild(textArea);
  }
}